import shopifyConfigApi from 'shopifyConfig/gateways/shopifyConfig-api';
import { handleApiCall } from 'utils/handleApiCallController.js';
import { EVENTS } from 'shopifyConfig/controllers/events.js';

export async function getDashboardData(eventEmitter, params) {
  try {
    const data = await shopifyConfigApi.getDashboardData(params);
    eventEmitter.emit('GET_SHOPIFY_DASHBOARD_DATA_SUCCESS', data);
  } catch (error) {
    eventEmitter.emit('GET_SHOPIFY_DASHBOARD_DATA_FAILURE');
  }
}

/**
 * Sends a request to close the Shopify embedded app window by calling the specified Shopify middleware URL.
 * This function sends a GET request to the `/connect` endpoint with the provided parameters.
 *
 * @param {Object} params - Parameters for the API request to close the Shopify window.
 * @param {string} params.id - A unique identifier for the session or operation.
 * @param {string} params.ref_id - A reference ID to track the specific operation, typically for logging purposes.
 * @param {string} params.shop - The subdomain of the Shopify store (e.g., 'test-paypal01') that will be used to identify the store.
 *
 * @returns {void} This function does not return any value. It performs the API call and resolves once completed.
 * The API request failure or success is handled by the underlying HTTP client.
 *
 * @throws {Error} The function does not explicitly throw errors. Any errors encountered during the API call
 * will be handled by the underlying HTTP client, and the promise will be rejected.
 */
export async function closeShopifyWindow(eventEmitter, params) {
  await handleApiCall(
    async () => {
      await shopifyConfigApi.closeShopifyWindow(params);
    },
    eventEmitter,
    EVENTS?.SHOPIFY_CLOSED_FAILURE,
  );
}

export async function installShopifyWindow(eventEmitter, params) {
  return await handleApiCall(
    async () => {
      return await shopifyConfigApi.installShopifyWindow(params);
    },
    eventEmitter,
    EVENTS?.SHOPIFY_CLOSED_FAILURE,
  );
}
